import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { NetworkStatus } from '@cbridge-utils/network';
import { PriceFilteringRuleAction } from './priceFilteringRule.action';
import { priceFilteringRuleInitialState } from './priceFilteringRule.constant';

export const priceFilteringRuleReducer = reducerWithInitialState(priceFilteringRuleInitialState)
  .case(PriceFilteringRuleAction.loadList.started, (state) => {
    return {
      ...state,
      networkStatus: NetworkStatus.Started,
    };
  })
  .case(PriceFilteringRuleAction.loadList.done, (state, payload) => {
    return {
      ...state,
      list: payload.result,
      networkStatus: NetworkStatus.Done,
    };
  })
  .case(PriceFilteringRuleAction.loadList.failed, (state) => {
    return {
      ...state,
      networkStatus: NetworkStatus.Failed,
    };
  })
  .case(PriceFilteringRuleAction.destroy, () => ({
    ...priceFilteringRuleInitialState,
  }));
